export default __webpack_public_path__ + "static/media/loader.bcd4f7aa.svg";